module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1523-80792cda808071d773b5e3e8af62e109.png";